import { combineReducers } from 'redux'

import AppInitStore from 'redux/reducers/AppInit'
import AuthStore from 'redux/reducers/Authentication'
import AlertStore from 'redux/reducers/Applications/Alert'
import SnackbarStore from 'redux/reducers/Snackbar'

// Data platform
import SourceStore from 'redux/reducers/DataPlatform/connections/Sources'
import SourceTableStore from 'redux/reducers/DataPlatform/connections/SourceTable'
import CustomEndpointStore from 'redux/reducers/DataPlatform/connections/CustomEndpoints'
import SimTableStore from 'redux/reducers/DataPlatform/SimTable'
import DataPlatformSIMStore from 'redux/reducers/DataPlatform/SIM'

// Admin
import CompanyStore from 'redux/reducers/Companies'
import CompanyGroupStore from 'redux/reducers/CompanyGroups'
import IntegrationStore from 'redux/reducers/Integrations'
import EconomySetStore from 'redux/reducers/EconomySets'
import RealEstateStore from 'redux/reducers/RealEstates'
import MyScopeStore from 'redux/reducers/MyScopes'
import AvailableUnitsStore from 'redux/reducers/AvailableUnits'
import AllocationKeyStore from 'redux/reducers/AllocationKeys'
import EntityStore from 'redux/reducers/Entities'
import SliceStore from 'redux/reducers/Slices'
import OrganizationalUnitsStore from 'redux/reducers/OrganizationalUnits'

// Applications
import OntologyStore from 'redux/reducers/Applications/Ontology'
import AppsDataProductStore from 'redux/reducers/Applications/DataProducts'
import AppsDatasetStore from 'redux/reducers/Applications/Datasets'

// Dashboards
import AccountStore from 'redux/reducers/Accounts'
import AttributeOptionStore from 'redux/reducers/AttributeOptions'
import CustomFieldStore from 'redux/reducers/CustomFields'
import DashboardGroupStore from 'redux/reducers/DashboardGroups'
import FilterOptionStore from 'redux/reducers/FilterOptions'
import KPIDashboardStore from 'redux/reducers/Dashboards'
import WidgetStore from 'redux/reducers/Widgets'
import MetricStore from 'redux/reducers/Metrics'
import ListsStore from 'redux/reducers/Lists'
import ResourceFilterStore from 'redux/reducers/ResourceFilter'
import KpiVariableStore from 'redux/reducers/KpiVariables'
import KpiVariableOptionStore from 'redux/reducers/KpiVariableOptions'
import DashboardFolderStore from 'redux/reducers/DashboardFolders'
import DashboardExampleStore from 'redux/reducers/DashboardExamples'
import TagOptionStore from 'redux/reducers/TagOptions'
import GlobalFilterStore from 'redux/reducers/GlobalFilter'
import TestEnvironmentStore from 'redux/reducers/TestEnvironment'
import ApiKeyStore from 'redux/reducers/ApiKeys'
import SavedDashboardFilterStore from 'redux/reducers/SavedDashboardFilters'
import CategoryStore from 'redux/reducers/Categories'
import ExportTableStore from 'redux/reducers/ExportTables'

// Metrics
import GroupKeyMetricLinkerStore from 'redux/reducers/GroupKeyMetricLinker'
import KeyMetricStore from 'redux/reducers/KeyMetrics'
import ResourceKeyMetricLinkerStore from 'redux/reducers/ResourceKeyMetricLinker'

// Groups
import GroupStore from 'redux/reducers/Groups'

// Comments
import CommentStore from 'redux/reducers/Comments'

// Reports
import ReportStore from 'redux/reducers/Reports'
import ResourceStatusesStore from 'redux/reducers/ResourceStatuses'

// Analyses
import AnalysisStore from 'redux/reducers/Analyses'

// MCP tokens

// Analysis types (registry served by the backend)
import AnalysisTypeStore from 'redux/reducers/AnalysisTypes'

// Analysis generations (per-customer jobs)
import AnalysisGenerationStore from 'redux/reducers/AnalysisGenerations'

// Tasks
import TaskStore from 'redux/reducers/Tasks'

// Config
import ConfigStore from 'redux/reducers/Configs'

// Status banner
import StatusBannerStore from 'redux/reducers/StatusBanner'

// Customization
import CustomizationStore from 'redux/reducers/Customization'

// reducers for internal use
import InternalAccountStore from 'redux/reducers/internal/Accounts'
import InternalCustomerStore from 'redux/reducers/internal/Customers'
import CustomerAgreementsStore from 'redux/reducers/internal/CustomerAgreements'
import InternalDerivedMetricStore from 'redux/reducers/internal/DerivedMetrics'
import InternalStatusBannerStore from 'redux/reducers/internal/StatusBanner'
import InternalSimFlawStore from 'redux/reducers/internal/SimFlaws'
import InternalSimChatStore from 'redux/reducers/internal/SimChats'
import InternalDataRunsStore from 'redux/reducers/internal/DataRuns'
import InternalDataRerunsStore from 'redux/reducers/internal/DataReruns'
import NpsStore from 'redux/reducers/NPS'
import ObjectSizeMapperStore from 'redux/reducers/internal/ObjectSizeMapper'
import CredentialsGroupsStore from 'redux/reducers/CredentialsGroups'

import NavigationMenuStore from 'redux/reducers/NavigationMenu'

// DashboardPage
import DashboardPageStore from 'redux/reducers/DashboardPage'

// Currency converter
import CurrencyConverterStore from 'redux/reducers/CurrencyConverter'

export default combineReducers({
  AllocationKeyStore,
  AppInitStore,
  CurrencyConverterStore,
  ApiKeyStore,
  AttributeOptionStore,
  AuthStore,
  CategoryStore,
  CompanyStore,
  CompanyGroupStore,
  IntegrationStore,
  CustomerAgreementsStore,
  CustomizationStore,
  CredentialsGroupsStore,
  CustomFieldStore,
  DashboardGroupStore,
  WidgetStore,
  EconomySetStore,
  EntityStore,
  SliceStore,
  ExportTableStore,
  FilterOptionStore,
  GlobalFilterStore,
  GroupKeyMetricLinkerStore,
  GroupStore,
  SourceStore,
  SourceTableStore,
  AlertStore,
  MetricStore,
  RealEstateStore,
  MyScopeStore,
  AvailableUnitsStore,
  OntologyStore,
  AppsDataProductStore,
  AppsDatasetStore,
  CustomEndpointStore,
  SimTableStore,
  DataPlatformSIMStore,
  KPIDashboardStore,
  InternalAccountStore,
  InternalSimFlawStore,
  InternalSimChatStore,
  InternalDataRunsStore,
  InternalDataRerunsStore,
  InternalDerivedMetricStore,
  InternalStatusBannerStore,
  AccountStore,
  SnackbarStore,
  ListsStore,
  StatusBannerStore,
  TagOptionStore,
  CommentStore,
  TaskStore,
  ConfigStore,
  InternalCustomerStore,
  ResourceFilterStore,
  KpiVariableStore,
  KpiVariableOptionStore,
  SavedDashboardFilterStore,
  NpsStore,
  DashboardFolderStore,
  ReportStore,
  ResourceStatusesStore,
  AnalysisStore,
  AnalysisGenerationStore,
  AnalysisTypeStore,
  DashboardExampleStore,
  NavigationMenuStore,
  DashboardPageStore,
  KeyMetricStore,
  ResourceKeyMetricLinkerStore,
  OrganizationalUnitsStore,
  ObjectSizeMapperStore,
  TestEnvironmentStore
})
